import { render } from "./ProfilView.vue?vue&type=template&id=64988447"
import script from "./js/profilView.js?vue&type=script&lang=js&external"
export * from "./js/profilView.js?vue&type=script&lang=js&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__